import { useCallback } from "react";
import { CheckboxInput } from "../lib";

type Props = {
  id: number;
  name: string;
  value: boolean;
  onChange: (id: number, active: boolean) => void;
};

export function CityAreaInput({ id, name, onChange, ...rest }: Props) {
  // Handlers
  const handleChange = useCallback(
    (_name: "area", newValue: boolean) => {
      onChange(id, newValue);
    },
    [id, onChange]
  );

  // Render
  return (
    <CheckboxInput {...rest} name="area" label={name} onChange={handleChange} />
  );
}
